import { render, staticRenderFns } from "./marketingActivity.vue?vue&type=template&id=2431f92c&scoped=true"
import script from "./marketingActivity.vue?vue&type=script&lang=js"
export * from "./marketingActivity.vue?vue&type=script&lang=js"
import style0 from "./marketingActivity.vue?vue&type=style&index=0&id=2431f92c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2431f92c",
  null
  
)

export default component.exports